var $cb692704ed999856$exports = {};
let $cb692704ed999856$var$savedCaptchaCode = "";
// ----------------------------------------------------
// 1. Country Codes API & Select Handling
// ----------------------------------------------------
async function $cb692704ed999856$var$loadCountryCodes() {
    const countrySelect = document.getElementById("countryCode");
    if (!countrySelect) return;
    try {
        const apiBase = "https://qkkalabs.com";
        const response = await fetch(`${apiBase}/blog/api/metadata?country_codes=true`);
        const data = await response.json();
        countrySelect.innerHTML = "";
        if (data?.data?.country_codes) data.data.country_codes.forEach((country)=>{
            const option = document.createElement("option");
            option.value = country.value;
            option.textContent = country.label;
            option.dataset.code = country.value;
            option.dataset.label = country.label;
            countrySelect.appendChild(option);
        });
        // Default selection: India (+91)
        countrySelect.value = "+91";
        $cb692704ed999856$var$collapseToCode();
    } catch (error) {
        console.error("Error loading country codes:", error);
    }
}
function $cb692704ed999856$var$restoreLabels() {
    const countrySelect = document.getElementById("countryCode");
    if (!countrySelect) return;
    Array.from(countrySelect.options).forEach((option)=>{
        option.textContent = option.dataset.label || option.value;
    });
}
function $cb692704ed999856$var$collapseToCode() {
    const countrySelect = document.getElementById("countryCode");
    if (!countrySelect) return;
    $cb692704ed999856$var$restoreLabels();
    const selectedOption = countrySelect.options[countrySelect.selectedIndex];
    if (selectedOption) selectedOption.textContent = selectedOption.dataset.code || selectedOption.value;
}
// ----------------------------------------------------
// 2. CAPTCHA API & Handling
// ----------------------------------------------------
const $cb692704ed999856$var$createCaptchaImage = async ()=>{
    const captchaBox = document.getElementById("captchaImage");
    if (captchaBox) captchaBox.innerHTML = '<div class="w-[8.375rem] h-[3.125rem] border border-gray-300 animate-pulse bg-gray-100 rounded"></div>';
    try {
        const apiBase = "https://qkkalabs.com";
        const response = await fetch(`${apiBase}/blog/api/captcha`, {
            method: "GET"
        });
        if (!response.ok) throw new Error("Captcha API failed");
        const result = await response.json();
        $cb692704ed999856$var$savedCaptchaCode = result.captcha_0 || "";
        if (captchaBox) captchaBox.innerHTML = `
        <img
          src="${result.image_url}"
          alt="captcha"
          class="h-[3.125rem] w-[8.375rem] object-contain rounded"
        />
      `;
    } catch (error) {
        console.error("Captcha Error:", error);
        if (captchaBox) captchaBox.innerHTML = '<div class="text-xs text-red-500 font-medium px-2 flex items-center justify-center h-full">Captcha failed</div>';
    }
};
window.createCaptchaImage = $cb692704ed999856$var$createCaptchaImage;
// ----------------------------------------------------
// 3. Helper Focus & Validations
// ----------------------------------------------------
const $cb692704ed999856$var$focusField = (id)=>{
    const el = document.getElementById(id);
    if (el) el.focus();
};
const $cb692704ed999856$var$validateName = (name)=>{
    if (!name || name.length < 3) {
        alert("Please enter a valid full name (at least 3 characters).");
        $cb692704ed999856$var$focusField("fullName");
        return false;
    }
    return true;
};
const $cb692704ed999856$var$validateEmail = (email)=>{
    if (!email) {
        alert("Please enter your email address.");
        $cb692704ed999856$var$focusField("email");
        return false;
    }
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!pattern.test(email)) {
        alert("Please enter a valid email address (e.g. name@example.com).");
        $cb692704ed999856$var$focusField("email");
        return false;
    }
    const localPart = email.split("@")[0];
    const dotCount = (localPart.match(/\./g) || []).length;
    if (dotCount > 2) {
        alert("Please enter a valid email address (e.g. name@example.com).");
        $cb692704ed999856$var$focusField("email");
        return false;
    }
    return true;
};
const $cb692704ed999856$var$validatePhone = (phone)=>{
    const cleaned = phone.replace(/\D/g, "");
    if (cleaned.length < 7 || cleaned.length > 15) {
        alert("Please enter a valid phone number (7 to 15 digits) with country code.");
        $cb692704ed999856$var$focusField("Phone_number");
        return null;
    }
    return cleaned;
};
const $cb692704ed999856$var$validateCaptcha = ()=>{
    const captchaInput = document.getElementById("captchaInput")?.value.trim();
    if (!captchaInput) {
        alert("Please enter the CAPTCHA code shown in the image.");
        $cb692704ed999856$var$focusField("captchaInput");
        return false;
    }
    return true;
};
const $cb692704ed999856$var$validateMessage = (message)=>{
    const trimmedMessage = message?.trim();
    if (!trimmedMessage) return true; // Optional field
    if (trimmedMessage.length < 10) {
        alert("Please enter a valid message (at least 10 characters).");
        $cb692704ed999856$var$focusField("project");
        return false;
    }
    return true;
};
// ----------------------------------------------------
// 4. Form Submit Handler
// ----------------------------------------------------
const $cb692704ed999856$var$FormSubmit = async (e)=>{
    if (e) e.preventDefault();
    const submitBtn = document.getElementById("form-button");
    if (submitBtn && submitBtn.disabled) return;
    // Honeypot check
    const honeypot = document.getElementById("honeypot");
    if (honeypot && honeypot.value !== "") return;
    const name = document.getElementById("fullName")?.value.trim() || "";
    const email = document.getElementById("email")?.value.trim() || "";
    const phoneRaw = document.getElementById("Phone_number")?.value.trim() || "";
    const companyName = document.getElementById("company_name")?.value.trim() || "";
    const areaOfInterest = document.getElementById("area_of_interest")?.value || "";
    const projectBrief = document.getElementById("project")?.value.trim() || "";
    const captchaInput = document.getElementById("captchaInput")?.value.trim() || "";
    const countrySelect = document.getElementById("countryCode");
    const countryCode = countrySelect?.value || "";
    // Perform validations
    if (!$cb692704ed999856$var$validateName(name)) return;
    if (!$cb692704ed999856$var$validateEmail(email)) return;
    const cleanedPhone = $cb692704ed999856$var$validatePhone(phoneRaw);
    if (!cleanedPhone) return;
    if (!$cb692704ed999856$var$validateMessage(projectBrief)) return;
    if (!$cb692704ed999856$var$validateCaptcha()) return;
    if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "Submitting...";
    }
    // Construct description combining interest & brief if present
    let description = projectBrief;
    if (areaOfInterest) description = `[Primary Interest: ${areaOfInterest}] ${projectBrief}`.trim();
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", cleanedPhone);
    formData.append("company_name", companyName);
    formData.append("country_code", countryCode);
    formData.append("description", description);
    formData.append("captcha_0", $cb692704ed999856$var$savedCaptchaCode);
    formData.append("captcha_1", captchaInput);
    formData.append("source", "contact-us");
    formData.append("user_agent", navigator.userAgent);
    try {
        const apiBase = "https://qkkalabs.com";
        const response = await fetch(`${apiBase}/blog/api/contact-us`, {
            method: "POST",
            body: formData
        });
        if (!response.ok) throw new Error("Form submission failed");
        const result = await response.json();
        // Store contact info for Thank You page
        localStorage.setItem("contact_name", result?.data?.name || name);
        localStorage.setItem("contact_email", result?.data?.email || email);
        // Redirect to Thank You page
        window.location.href = "/thankyou";
    } catch (error) {
        console.error("Form submission error:", error);
        alert("Form submission failed. Please try again.");
        if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = "SUBMIT REQUEST";
        }
        $cb692704ed999856$var$createCaptchaImage();
    }
};
window.FormSubmit = $cb692704ed999856$var$FormSubmit;
// ----------------------------------------------------
// 5. DOM Initialization & Event Listeners
// ----------------------------------------------------
document.addEventListener("DOMContentLoaded", ()=>{
    const countrySelect = document.getElementById("countryCode");
    if (countrySelect) {
        countrySelect.addEventListener("mousedown", $cb692704ed999856$var$restoreLabels);
        countrySelect.addEventListener("change", $cb692704ed999856$var$collapseToCode);
    }
    const captchaRefreshBtn = document.getElementById("refreshCaptcha");
    if (captchaRefreshBtn) captchaRefreshBtn.addEventListener("click", (e)=>{
        e.preventDefault();
        $cb692704ed999856$var$createCaptchaImage();
    });
    const form = document.getElementById("de-contact-form");
    if (form) form.addEventListener("submit", $cb692704ed999856$var$FormSubmit);
    $cb692704ed999856$var$loadCountryCodes();
    $cb692704ed999856$var$createCaptchaImage();
});
// Page cache reload fix
window.addEventListener("pageshow", (event)=>{
    if (event.persisted) window.location.reload();
});


//# sourceMappingURL=data-engineering-services.d1451c88.js.map
